module.exports = __webpack_public_path__ + "static/media/trainers-logo.a699ed68.png";